import React from "react";
import { useParams } from "react-router-dom";
import withStyles from "@material-ui/styles/withStyles";
import { getAppPath } from "constants/path";
import TabBar from "storybookComponents/TabBar";
import ApprovalProcess from "./ApprovalProcess";
import BrokerUpload from "./BrokerUpload";
import BccList from "./BccList";
import styles from "./styles";
import { tabs } from "./utils";

const steps = {
  0: "approval-process",
  1: "broker-upload",
  2: "bcc-list",
};

const Settings = ({
  setTitle,
  classes,
  history,
  setOriginNavItems,
  hyeventsAccessApproval,
  isNotificationsBarVisible,
  ...rest
}) => {
  const { step } = useParams();
  const [tabIndex, setTabIndex] = React.useState(0);

  const handleTabChange = (index) => {
    let keyOfSteps = index;
    setTabIndex(index);
    if (!hyeventsAccessApproval) {
      keyOfSteps = keyOfSteps + 1;
    }
    history.push(getAppPath() + "/settings/" + steps[keyOfSteps]);
  };

  const setIndexValue = () => {
    let index = step === "approval-process" ? 0 : step === "broker-upload" ? 1 : 2;
    if (!hyeventsAccessApproval) {
      index = index - 1;
    }
    setTabIndex(index);
  };

  const renderContent = () => {
    if (hyeventsAccessApproval) {
      switch (tabIndex) {
        case 0:
          return <ApprovalProcess {...rest} />;
        case 1:
          return <BrokerUpload {...rest} event />;
        case 2:
          return <BccList {...rest} />;
        default:
          return <ApprovalProcess />;
      }
    } else {
      switch (tabIndex) {
        case 0:
          return <BrokerUpload {...rest} event />;
        case 1:
          return <BccList {...rest} />;
        default:
          return <BrokerUpload {...rest} event />;
      }
    }
  };

  // Init actions
  React.useEffect(() => {
    setTitle([{ label: "Events - Settings", link: "#", active_state: true }]);
    setOriginNavItems(rest.orgLevel);
  }, []);

  React.useEffect(() => {
    setIndexValue();
  }, [step]);

  return (
    <div className={classes.root}>
      <div className={classes.headerBar}>
        <TabBar
          tabs={hyeventsAccessApproval ? tabs : tabs.slice(1)}
          onChange={handleTabChange}
          index={tabIndex}
        />
      </div>
      <div className={`${classes.contentContainer} ${isNotificationsBarVisible && classes.customRoot}`}>{renderContent()}</div>
    </div>
  );
};

export default withStyles(styles)(Settings);
